// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__cVrCz {
    max-height: 50vh;
    overflow-y: auto;
}

.styles_row__RGh88 {
    align-items: center;
    display: flex;
    justify-content: space-evenly;
    margin-top: 1rem;
}

.styles_add_button__I1yzY {
    color: #18316e !important;
    cursor: pointer !important;
    font-size: 2rem !important;
}

.styles_add_button__I1yzY:hover{
    transform: scale(1.1) !important;
}

.styles_trash_button__9sLB1{
    color: red !important;
    cursor: pointer !important;
    font-size: 1.7rem !important;
}

.styles_trash_button__9sLB1:hover{
    transform: scale(1.1) !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Relatorios/TabFiltros/styles.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;AACpC","sourcesContent":[".container {\n    max-height: 50vh;\n    overflow-y: auto;\n}\n\n.row {\n    align-items: center;\n    display: flex;\n    justify-content: space-evenly;\n    margin-top: 1rem;\n}\n\n.add_button {\n    color: #18316e !important;\n    cursor: pointer !important;\n    font-size: 2rem !important;\n}\n\n.add_button:hover{\n    transform: scale(1.1) !important;\n}\n\n.trash_button{\n    color: red !important;\n    cursor: pointer !important;\n    font-size: 1.7rem !important;\n}\n\n.trash_button:hover{\n    transform: scale(1.1) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__cVrCz`,
	"row": `styles_row__RGh88`,
	"add_button": `styles_add_button__I1yzY`,
	"trash_button": `styles_trash_button__9sLB1`
};
export default ___CSS_LOADER_EXPORT___;
